/**
 * @generated by @interxfi/j5-codegen - do not edit */

import { buildMergedRequestInit, makeRequest } from '@interxfi/api-client/request';
import type { IxmUserauthV1ProgramTenantServiceCreateProgramTenantRequest, IxmUserauthV1ProgramTenantServiceCreateProgramTenantResponse } from '@interxfi/types';

export const IXM_USERAUTH_V1_PROGRAM_TENANT_SERVICE_CREATE_PROGRAM_TENANT_AUDIENCE = ['platform', 'organization'];

export async function ixmUserauthV1ProgramTenantServiceCreateProgramTenant(baseUrl: string | undefined, request?: IxmUserauthV1ProgramTenantServiceCreateProgramTenantRequest, requestInit?: RequestInit): Promise<IxmUserauthV1ProgramTenantServiceCreateProgramTenantResponse | undefined> { return makeRequest<IxmUserauthV1ProgramTenantServiceCreateProgramTenantResponse, IxmUserauthV1ProgramTenantServiceCreateProgramTenantRequest>(...buildMergedRequestInit('POST', baseUrl || '', '/portal/userauth/v1/program', request, requestInit)); }

